// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Alert_wrapper__eJTjm","isActive":"Alert_isActive__VLjDh","popUp":"Alert_popUp__DaV80","title":"Alert_title__N9Omm","cancelButton":"Alert_cancelButton__ZpPaz"};